import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-admin-nav-menu',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-admin-nav-menu.component.html',
  styleUrl: './app-admin-nav-menu.component.css'
})
export class AppAdminNavMenuComponent {
  @Input() activePanel: string = 'personal';
  @Output() panelChange = new EventEmitter<string>();

  setActivePanel(panel: string): void {
    this.panelChange.emit(panel);
  }
}
